import { jsx } from "@emotion/react/jsx-runtime";
import { useTheme, Global } from "@emotion/react";
function ensureArray(value) {
  let isEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : value2 => value2 == null || value2 === "";
  if (Array.isArray(value)) {
    return value;
  }
  if (isEmpty(value)) {
    return [];
  }
  return [value];
}
function GlobalStyles(_ref) {
  let {
    ...restProps
  } = _ref;
  const theme = useTheme();
  let {
    fonts = {},
    fontFamily = [Object.keys(fonts)[0], "system-ui", "sans-serif"].filter(Boolean).join(", ")
  } = (theme == null ? void 0 : theme.typography) || {};
  let fontFaceDeclarations = [];
  Object.entries(fonts).forEach(_ref2 => {
    let [fontFamily2, value] = _ref2;
    if (typeof value === "string") {
      value = {
        src: value
      };
    }
    let {
      src,
      fontWeight = "100 900",
      fontDisplay = "swap",
      fontStyle = ["normal", "italic"],
      ...rest
    } = value;
    if (!src) {
      throw new Error(`No src provided for font "${fontFamily2}" in theme`);
    }
    fontStyle = ensureArray(fontStyle);
    if (typeof src !== "object") {
      src = fontStyle.reduce((acc, fontStyle2) => ({
        ...acc,
        [fontStyle2]: src
      }), {});
    }
    Object.entries(src).forEach(_ref3 => {
      let [fontStyle2, src2] = _ref3;
      if (!/^url\(/.test(src2)) {
        src2 = `url("${src2}") format("${src2.split(".").at(-1)}")`;
      }
      let fontFaceDeclaration = {
        fontFamily: `"${fontFamily2}"`,
        fontStyle: fontStyle2,
        fontWeight,
        fontDisplay,
        src: src2,
        ...rest
      };
      fontFaceDeclarations.push(fontFaceDeclaration);
    });
  });
  const styles = [...fontFaceDeclarations.map(fontFaceDeclaration => ({
    "@font-face": fontFaceDeclaration
  })), {
    body: {
      fontFamily,
      margin: 0,
      ...theme.styleUtils.colorTheme("white"),
      accentColor: theme.getColor("primary")
    },
    ".wsui-screen-only": {
      "@media not screen": {
        display: "none !important"
      }
    }
  }];
  return /* @__PURE__ */jsx(Global, {
    styles,
    ...restProps
  });
}
export { GlobalStyles as default };